var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.id,
        "modal-class": _vm.modalClass,
        "dialog-class": _vm.dialogClass,
        "no-close-on-backdrop": _vm.noCloseOnBackdrop,
        centered: _vm.centered,
        "hide-footer": _vm.hideFooter,
        "hide-header": _vm.hideHeader,
        "no-enforce-focus": true,
      },
      on: {
        ok: _vm.ok,
        close: _vm.close,
        cancel: _vm.close,
        hidden: _vm.close,
        hide: _vm.close,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "modal-header",
            fn: function () {
              return [_vm._t("modal-header")]
            },
            proxy: true,
          },
          {
            key: "modal-footer",
            fn: function () {
              return [_vm._t("modal-footer")]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
      model: {
        value: _vm.open,
        callback: function ($$v) {
          _vm.open = $$v
        },
        expression: "open",
      },
    },
    [_vm._v(" "), [_vm._t("default")]],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }